<div *ngIf="needsRefresh" class="fade-in fade-out" id="refresh-tool">
    <gsp-button
        [type]="ButtonType.Icon"
        (action)="refreshMap()"
        title="{{ 'TCS.Mapviewer.MapNeedsRefresh' | translate }}"
        iconClass="icon_line_refresh i32"
    ></gsp-button>
</div>
